import { useMemo } from 'react';
import { useFlowEditorContext } from '../../../../../context';
import { useSelectedNode } from './useSelectedNode';
/**
 * @param  {string} field
 * @return {string|undefined} error
 */
export const useValidationMessage = (field, skipValidation) => {
  const [{ validationErrors }] = useSelectedNode();
  const { isValidateOn } = useFlowEditorContext();

  return useMemo(() => {
    if (!skipValidation && !isValidateOn) {
      return '';
    }

    return validationErrors?.find(({ key }) => key === field)?.label;
  }, [field, isValidateOn, validationErrors, skipValidation]);
};

const RE_KEY = /\[(\d+)]/;

/**
 * @param  {string} field
 * @return {string|undefined} error
 */
export const useValidationMessages = (field, skipValidation) => {
  const [{ validationErrors }] = useSelectedNode();
  const { isValidateOn } = useFlowEditorContext();

  if (!skipValidation && !isValidateOn) return '';

  return validationErrors.reduce((acc, m) => {
    if (!m.key.startsWith(`${field}[`)) {
      acc[m.key] = m.label;
      return acc;
    }
    const indexMatch = m?.key?.match(RE_KEY);
    const index = indexMatch?.[1] ?? '';
    acc[index] = m.label;
    return acc;
  }, {});
};
